import React from "react";
import { getPrettyDate, format_payout_commas, format_decimal_integer } from "../lib/format";
import { matchLabels } from "../poolTypes";

// A tier's Payout fields end in the tier, e.g. nett9_10 for "9/10", unless
// tierFields gives them another ending.
const tierField = (result, field, tier) => field + (result.tierFields?.[tier] ?? tier.replace("/", "_"));

const PayoutTier = ({ result, item, tier }) => (
  <>
    {`Results: (${tier})`}
    <br />
    {`Net ${tier}: R`}
    {format_payout_commas(item[tierField(result, "nett", tier)])}
    <br />
    Winners: {format_decimal_integer(item[tierField(result, "tickets", tier)])}
    <br />
    Dividend: R{format_payout_commas(item[tierField(result, "value", tier)])}
    <br />
    <br />
  </>
);

// A lower tier is left out when nobody won it, except the emptyTier, which shows zeros.
const LowerPayoutTier = ({ result, item, tier }) => {
  if (item[tierField(result, "tickets", tier)]) {
    return (
      <div>
        <PayoutTier result={result} item={item} tier={tier} />
      </div>
    );
  }
  if (tier !== result.emptyTier) {
    return null;
  }
  return (
    <div>
      {`Results: (${tier})`}
      <br />
      {`Net ${tier}: R0`}
      <br />
      Winners: 0<br />
      Dividend: 0<br />
      <br />
    </div>
  );
};

const TieredPayout = ({ result, item }) => (
  <div className="panel poolinformation">
    Winning Combination: {item.combination}
    <br />
    Status: Official
    <br />
    <br />
    {result.lowerTiers.map((tier) => (
      <LowerPayoutTier key={tier} result={result} item={item} tier={tier} />
    ))}
    <PayoutTier result={result} item={item} tier={result.topTier} />
  </div>
);

const SinglePayout = ({ item }) => (
  <div className="panel poolinformation">
    Net Pool: R{format_payout_commas(item.nett)}
    <br />
    Winning Combination: {item.combination}
    <br />
    Status: Official
    <br />
    Winners: {format_decimal_integer(item.tickets)}
    <br />
    Dividend: R{format_payout_commas(item.dividend)}
  </div>
);

// One Program's Result, rendered from its Pool Type's config (src/poolTypes.js).
const Result = ({ poolType, item }) => {
  const { result } = poolType;
  return (
    <div>
      <div className="pooldateindicator4R">
        {/* Split into text nodes as the old S{N}Result had them, so it matches to the pixel. */}
        {getPrettyDate(item.RowKey)}
        {` - ${result.label} `}
        {item.league_title}
        {!result.hidesProgramCode && <> ({item.program_code})</>}
      </div>
      <table className="pooltable">
        <tr>
          <th>Match</th>
          <th>{result.teamAHeading ?? "Team A"}</th>
          <th>{result.scoreHeading ?? "Score"}</th>
          <th>Team B</th>
        </tr>
        {matchLabels(poolType).map((matchLabel, i) => (
          <tr key={matchLabel}>
            <td className="bold">{matchLabel}</td>
            <td>{item[`match${i + 1}TeamA`]}</td>
            <td>{item[`match${i + 1}Result`]}</td>
            <td className="righttext">{item[`match${i + 1}TeamB`]}</td>
          </tr>
        ))}
      </table>
      {result.topTier ? <TieredPayout result={result} item={item} /> : <SinglePayout item={item} />}
    </div>
  );
};

export default Result;
